import { PAYMENT_METHOD_ID } from '@/core/payment-methods/constants';

export function redirectLogin(paymentMethodId: PAYMENT_METHOD_ID, lang: string) {
    const url = encodeURIComponent(`${window.location.href}&paymentMethod=${paymentMethodId}`);

    window.location.href = `account/challenge?returnUrl=${url}&lang=${lang}`;
}
